import type { StoreConfiguration } from '../types/storeConfig';
import type { WindowWika } from '../types/window';

export default function withBaseUrl({
  config,
  type,
  url,
}: {
  config: StoreConfiguration;
  type?: 'search';
  url: string;
}) {
  const _window = window as unknown as WindowWika;
  let baseUrl: string | undefined;

  if (_window.isStorybook) {
    baseUrl = 'http://localhost:9000';
  } else if (type === 'search' && config.pt_search_base_url) {
    baseUrl = config.pt_search_base_url;
  }

  if (!baseUrl) {
    return url;
  }

  return new URL(url, baseUrl);
}
